import { AsyncPipe, CommonModule } from "@angular/common";
import { RouterModule, RouterOutlet } from "@angular/router";
import { AssistantComponent } from "./core/components/assistant/assistant.component";
import { CartDrawerComponent } from "./core/components/cart-drawer/cart-drawer.component";
import { CollectionsMenuMobileComponent } from "./core/components/collections-menu-mobile/collections-menu-mobile.component";
import { HomePageComponent } from "./core/components/home-page/home-page.component";
import { LayoutFooterComponent } from "./core/components/layout/layout-footer.component";
import { LayoutHeaderComponent } from "./core/components/layout/layout-header.component";
import { LayoutComponent } from "./core/components/layout/layout.component";
import { MobileBottomNavComponent } from "./core/components/mobile-bottom-nav/mobile-bottom-nav.component";
import { ShopByMobileComponent } from "./custom/filters/shop-by-mobile/shop-by-mobile.component";

export const AppComponentImports = [
    AsyncPipe,
    CommonModule,
    RouterModule,
    RouterOutlet,
    // Components
    AssistantComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutFooterComponent,
    CollectionsMenuMobileComponent,
    CartDrawerComponent,
    HomePageComponent,
    ShopByMobileComponent,
    MobileBottomNavComponent
];
